import { PropsWithChildren } from "react";

export function MyProfileCard({ children }: PropsWithChildren) {
  return (
    <div className={"p-4 bg-white rounded-2xl shadow-lg shadow-slate-200/50"}>
      <div className={"space-y-4"}>{children ?? null}</div>
    </div>
  );
}
